import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/RecommendationSlotPreview.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/v2/recommendations/preview`;
	}
	preview(e) {
		return this.api.post(n.baseUrl, e);
	}
};
//#endregion
export { n as RecommendationSlotPreview };

//# sourceMappingURL=RecommendationSlotPreview.js.map